import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useEnquiry = (property) => {
  const empty = { name: "", phone: "", email: "", property, dates: "", guests: "", occasion: "", message: "" };
  const [form, setForm] = useState(empty);
  const [sending, setSending] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Thank you, your enquiry has been sent. We'll be in touch shortly.");
      setForm(empty);
    } catch (err) {
      toast.error("Something went wrong. Please try again, or reach us on WhatsApp.");
    } finally {
      setSending(false);
    }
  };

  return { form, set, submit, sending };
};
